/**
 * Diagnostics Collector for Bug Reporting.
 * Captures non-sensitive app state for triage.
 * No tokens, secrets, payment data, or raw response bodies.
 */

const MAX_RECENT_ERRORS = 5;
const MAX_ERROR_LEN = 300;

// Ring buffer for recent client errors
const _recentErrors = [];

/**
 * Record a client-side error string.
 * Called from global error handler or catch blocks.
 */
export function recordError(msg) {
  if (!msg) return;
  const str = String(msg).slice(0, MAX_ERROR_LEN);
  _recentErrors.push(str);
  if (_recentErrors.length > MAX_RECENT_ERRORS) {
    _recentErrors.shift();
  }
}

// Track last API error (endpoint + status only — no body)
let _lastApiError = null;

export function recordApiError(endpoint, status, requestId) {
  _lastApiError = {
    endpoint: String(endpoint || '').slice(0, 200),
    status: typeof status === 'number' ? status : null,
    request_id: requestId ? String(requestId).slice(0, 100) : null,
  };
}

/**
 * Collect diagnostics snapshot.
 * Returns a plain object safe for JSON serialization.
 */
export function collectDiagnostics() {
  return {
    // Route
    app_route: window.location.pathname + window.location.hash,

    // Platform
    platform: navigator.platform || null,
    user_agent: navigator.userAgent?.slice(0, 500) || null,
    language: navigator.language || null,

    // Screen
    screen_width: window.innerWidth,
    screen_height: window.innerHeight,

    // App state (from localStorage — no tokens)
    active_plan_id: localStorage.getItem('bm_active_plan_id') || null,
    active_session_id: localStorage.getItem('bm_active_session_id') || null,
    generation_route: localStorage.getItem('bm_generation_route') || null,
    plan_generation_reason: localStorage.getItem('bm_plan_gen_reason') || null,

    // Errors
    recent_errors: [..._recentErrors],
    last_api_error: _lastApiError ? { ..._lastApiError } : null,
  };
}

// Install global error listener
if (typeof window !== 'undefined') {
  window.addEventListener('error', (e) => {
    recordError(`${e.message} at ${e.filename}:${e.lineno}`);
  });
  window.addEventListener('unhandledrejection', (e) => {
    recordError(`Unhandled rejection: ${e.reason}`);
  });
}
